import React from 'react';
// PythonAppWrapper and LissajousApp are imported here because they are
// referenced in the 'items' array that will be passed to MultiGallery.
import PythonAppWrapper from './PythonAppWrapper';

import LissajousReactApp from './LissajousReactApp';
import LissajousApp from './LissajousApp';
import DrumMachinePython from './DrumMachinePython';
import DrumMachineReact from './DrumMachineReactApp';
import WorkletDrumMachine from './AudioWorklet-DrumMachine/drum-machine';

import _3dSimulation_03 from './3d-simulation-03'

import MultiGallery from './MultiGallery.js';
// import WaveformPlotterApp from './WaveformPlotterApp'; // Uncomment when you create this component

// Import your local images for web_apps_js
import LissajousThumb from './img/webapps/lissajous-02.jpg';
import DrumMachinePythonThumb from './img/webapps/drum-machine-python.jpg';
import DrumMachineReactThumb from './img/webapps/drum-machine-react-01.jpg';
import _3dSimulation_03Thumb from './img/webapps/3d_03_2.jpg';





/**
 * WebApps component to centralize all your web application showcases
 * using the MultiGallery component.
 * This component defines the list of apps and passes it to MultiGallery
 * for display.
 */
function WebApps({ 
setHasAcceptedTrackingCookies = () => {}, 
hasAcceptedTrackingCookies = true })
{
    // Define the items array for MultiGallery directly within this component.
    // This allows you to reference the imported React components (like LissajousApp)
    // that MultiGallery will dynamically render.
    const items = [
        // Example: Lissajous Patterns Generator as a 'webapp' type
        // {
        //     type: 'webapp', // The new type for web applications
        //     title: 'Lissajous Patterns Generator',
        //     description: 'An interactive tool to explore mesmerizing Lissajous patterns generated by oscillating signals.\nWritten in Python,',
        //     linkClass: 'web-app-item', // Optional: for custom styling of this item in the gallery grid
        //     component: LissajousApp, // <-- Pass the actual React component reference here
        //     renderUrl: 'https://lissajous-patterns-generator.onrender.com/', // <-- Your Render URL for the Python backend
        //     content: LissajousThumb, // Use the imported image variable
        //     extras: {
        //         title: 'View Code on GitHub', // Optional extra link
        //         url: 'https://github.com/rigomapoga/lissajous-patterns-generator/' // Replace with actual repo URL
        //     },
        //     tags: ['python', 'visualization'], // Added tags
        // },
        {
            type: 'webapp',
            title: 'Python Drum Machine',
            description: 'A classic drum machine experience, powered by a Python backend that delivers high-fidelity, pre-recorded drum samples in real time.',
            linkClass: 'web-app-item',
            component: DrumMachinePython, // Pass the DrumMachine React component         
            // For local testing, use 'http://localhost:5000'
            backendUrl: 'https://eight08-style-drum-machine.onrender.com/',
            
            image: DrumMachinePythonThumb, // Use the imported image variable
            extras: {
                title: 'View Code on GitHub', // Optional extra link
                url: 'https://github.com/rigomapoga/808-style-drum-machine'
            },
            tags: ['python', 'music'],
        },
        {
            type: 'webapp',
            title: 'React Drum Machine',
            description: 'A React version of the classic 808  drum machine that delivers high-fidelity, pre-recorded drum samples in real time.',
            linkClass: 'web-app-item',
            component: WorkletDrumMachine, // Pass the DrumMachine React component         
            // For local testing, use 'http://localhost:5000'            
            
            image: DrumMachineReactThumb, // Use the imported image variable
            // extras: {
            //     title: 'View Code on GitHub', // Optional extra link
            //     url: 'https://github.com/rigomapoga/808-style-drum-machine'
            // },
            tags: ['react', 'music'],
        },
        {
            type: 'webapp',
            title: 'Lissajous-React',
            description: 'An interactive tool to explore mesmerizing Lissajous patterns generated by oscillating signals.\nWritten in React.',
            linkClass: 'web-app-item',
            component: LissajousReactApp, // Pass the DrumMachine React component         
            // For local testing, use 'http://localhost:5000'
            image: LissajousThumb, // Use the imported image variable
            // extras: {
            //     title: 'View Code on GitHub', // Optional extra link
            //     url: 'https://github.com/rigomapoga/808-style-drum-machine'
            // },
            tags: ['react', 'visualization'],
        },
        {
            type: 'webapp',
            title: '3D test',
            description: 'An interactive 3D web application featuring a characer with dynamic movement,\ncamera controls and adaptive mobile touch controls',
            linkClass: 'web-app-item',
            component: _3dSimulation_03, // Pass the DrumMachine React component         
            // For local testing, use 'http://localhost:5000'
            image: _3dSimulation_03Thumb, // Use the imported image variable
            // extras: {
            //     title: 'View Code on GitHub', // Optional extra link
            //     url: 'https://github.com/rigomapoga/808-style-drum-machine'
            // },
            tags: ['react', 'visualization'],
        },
        // Placeholder for another web app: Waveform Plotter
        /*
        {
            type: 'webapp',
            title: 'Interactive Waveform Plotter',
            description: 'Visualize sine, square, and sawtooth waveforms and see how frequency and amplitude affect their shape.',
            linkClass: 'web-app-item',
            component: WaveformPlotterApp, // Uncomment when you create this component
            renderUrl: 'https://your-waveform-plotter-app.onrender.com/', // Replace with actual Render URL
            extras: {
                title: 'View Code on GitHub',
                url: 'https://github.com/yourusername/waveform-plotter-repo' // Replace with actual repo URL
            },
        },
        */
        // You can add other types of items here as well, e.g., 'youtube', 'image', 'html'
        // Just ensure your MultiGallery handles those types correctly.
    ];

    return (
        <div className="web-apps-container" id="page">
            {/* Optional: Add a general heading for your web apps section */}
            <h2 className="title text-style-04" style={{fontSize:'1em'}}>Interactive Web Applications</h2>

            {/* Render the MultiGallery component, passing the defined items */}
            {/* To disable navigation, pass a config object with showNavigationArrows set to false */}
            <MultiGallery items={items} config={{filterable: true, showNavigationArrows: false}} setHasAcceptedTrackingCookies={setHasAcceptedTrackingCookies} />


            {/* Any other content for your WebApps page can go here */}
        </div>
    );
}

export default WebApps;
